<template>
    <div>
        <top-navbar :breadcrumb="breadcrumb"></top-navbar>

        <div class="container-fluid mt--6">
            <div class="row">
                <div class="col-lg-4">
                    <user-card :user="learner"></user-card>
                </div>
                <div class="col-lg-8">
                    <registrations :registrations="registrations" :learner="learner" @change="reload">
                    </registrations>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import UserCard from '../auth/components/UserCard'
    import Registrations from './learner/Registrations';

    export default {

        components: {
            UserCard, Registrations
        },

        data() {
            return {
                learner: {},
                registrations: null,
            }
        },

        computed: {

            breadcrumb() {
                return [{
                    name: this.learner.name,
                }]
            }
        },

        beforeRouteEnter(to, from, next) {
            Vue.prototype.$loader.show()
            axios.get('/astral/api/front/dashboard/learners/'+to.params.learnerId+'/registrations')
            .then(resp => {
                next(vm => {
                    vm.registrations = resp.data.data
                    vm.learner = resp.data.included.learner
                    vm.$permissions.setRights(resp.data.included.rights)
                    vm.$loader.hide()
                })
            })
            .catch(err => {
                if (err.response.status == 403) {
                    next({ name: 'unauthorized' });
                }
            });
        },

        methods: {

            reload() {
                axios.get('/astral/api/front/dashboard/learners/'+this.learner.id+'/registrations')
                .then(resp => {
                    this.registrations = resp.data.data
                })
                .catch(err => {
                    this.$auth.handleErrorVm(err, this)
                })        
            }
        }
    }
</script>
